import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { getInitialState } from '../../../reducers/partitions';

export const usePartitionSetting = () => {
    const [partitions, setPartitions] = useState(Object.values(useSelector(((state) => state.partitions || {}))).map(({ buttonType, visible }) => ({id: buttonType, visible})));

    const handleResetClick = useCallback(() => setPartitions((getInitialState() || []).map(({ buttonType, visible }) => ({id: buttonType, visible}))), []);
    
    const handleCheckItem = useCallback(
        (index, checked) => setPartitions((oldState) => {
            const newState = [
                ...oldState,
            ];

            if (newState[index]) {
                newState[index] = {
                    ...newState[index],
                    visible: checked,
                };
            }

            return newState;
        }), [setPartitions]);

    return { partitions, setPartitions, handleResetClick, handleCheckItem };
};
